// extracted by mini-css-extract-plugin
module.exports = {"checkoutFlowOrderSummary":"CheckoutFlowOrderSummary_checkoutFlowOrderSummary__lDAxy"};